window.AmazonPrime = (function ($, util) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        state: {
            partnerRedirectUrl: '',
            initiated: 'initiated',
            expired: 'expired',
            notApplied: 'not_applied',
            rewardStatus: '',
            voucherCode: ''
        },
        elements: {
            attributes: {
                copyContent: 'data-copycontent',
                destination: 'data-destination'
            },
            buttons: {
                amazonPrimeSignupButtonClick: '#sign-up-button',
                amazonPrimeTermsModal: '#prime-terms-and-conditions-modal',
                amazonPrimeAcceptTermsAndConditionButtonClick: '#accept-terms-and-conditions',
                amazonPrimeCreditContinueModal: '#prime-credit-modal-continue',
                amazonPrimeCreditModal: '#prime-credit-modal',
                etikaLinkClick: '#etika-link',
                etikaLinkContinueClick: '#etika-link-continue',
                amazonPrimeSignupButtonComponent: '#amazon-prime-signup',
                amazonPrimeCopyCodeModalButton: '#copy-and-redeem-button',
                copyCodeButton: '#copy-code-and-go-button',
                amazonPrimeCopyCodeModalCloseButton: '#amazon-prime-voucher-code-modal .vds-modal__close',
                amazonPrimeCopyAndRedeemButton: '.vds-button-copy-and-redeem',
                amazonPrimeRevealCodeButton: '#vds-button-reveal-code',
                amazonPrimeRevealCodeAndRefreshButton: '#prime-reveal-code-and-refresh',
                amazonPrimeCurrentVoucherButton: '#prime-current-voucher-button',
                amazonPrimePreviousVoucherButton: '#prime-previous-voucher-button',
                amazonPrimeRenewedVoucherButton: '#prime-renewed-voucher-button'
            },
            ids: {
                amazonPrimeTermsModal: 'prime-terms-and-conditions-modal',
                amazonPrimeCreditModal: 'prime-credit-modal',
                amazonPrimeCreditContinueModal: 'prime-credit-modal-continue',
                amazonPrimeSignupButton: 'amazon-prime-signup',
                amazonPrimeVoucherCodeModal: 'amazon-prime-voucher-code-modal',
                amazonPrimeVoucherCode: '#voucher-code'
            },
            notifications: {
                amazonPrimeVoucherAllocationError: '#voucher-allocation-failed',
                amazonPrimeBenefitServiceDown: '#benefit-service-down'
            }
        },
        urls: {
            getMerchantSiteUrl: '/api/sitecore/AmazonPrimeSignup/getMerchantSiteUrl',
            allocateVoucherUrl: '/api/sitecore/AmazonPrimeSignup/allocateVoucher',
            errorPageUrl: '/error/error-page'
        },
        func: {
            init: function (viewData) {
                self.func.checkStatus.code(viewData);
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.buttons.amazonPrimeSignupButtonClick).on('click', self.func.handleSignUpButtonClick);
                $(self.elements.buttons.amazonPrimeAcceptTermsAndConditionButtonClick)
                    .on('click', self.func.handleTermsAndConditionsButtonClick);
                $(self.elements.buttons.etikaLinkClick).on('click', self.func.handleEtikaLink);
                $(self.elements.buttons.etikaLinkContinueClick).on('click', self.func.handleEtikaLinkContinue);
                $(self.elements.buttons.amazonPrimeCopyAndRedeemButton).on('click', self.func.copyVoucherCode);
                $(self.elements.buttons.amazonPrimeCopyCodeModalButton).on('click', self.func.copyVoucherCode);
                $(self.elements.buttons.amazonPrimeCopyCodeModalCloseButton).on('click', util.func.reloadPage);
                $(self.elements.buttons.amazonPrimeRevealCodeButton).on('click', self.func.allocateVoucher);
                $(self.elements.buttons.amazonPrimeRevealCodeAndRefreshButton).on('click', self.func.allocateVoucherAndRefresh);
                $(self.elements.buttons.copyCodeButton).on('click', self.func.copyVoucherCodeAndGo);
                $(self.elements.buttons.amazonPrimeCurrentVoucherButton).on('click', self.func.copyAndGo);
            },
            handleSignUpButtonClick: function () {
                self.func.getMerchantSiteUrl();
            },
            handleContinueButtonClick: function () {
                self.func.getMerchantSiteUrl();
            },
            handleTermsAndConditionsButtonClick: function () {
                self.func.closeTermsModal();
                self.func.openCreditModal();
            },
            handleEtikaLink: function () {
                self.func.closeCreditModal();
                self.func.redirectToExternalPartnerSite();
            },
            handleEtikaLinkContinue: function () {
                self.func.closeCreditContinueModal();
                self.func.redirectToExternalPartnerSite();
            },
            checkStatus: {
                code: function (viewData) {
                    self.state.partnerRedirectUrl = viewData.PartnerSiteRedirectLink;

                    if (viewData.VoucherCode !== null) {
                        self.state.voucherCode = viewData.VoucherCode;
                    }

                    let voucherBlockButtons = [];
                    voucherBlockButtons.push($(self.elements.buttons.amazonPrimeCurrentVoucherButton));
                    voucherBlockButtons.push($(self.elements.buttons.amazonPrimePreviousVoucherButton));
                    voucherBlockButtons.push($(self.elements.buttons.amazonPrimeRenewedVoucherButton));

                    // Filter out falsy values
                    voucherBlockButtons = voucherBlockButtons.filter(v => !!v);

                    for (let i = 0; i < voucherBlockButtons.length; i++) {
                        voucherBlockButtons[i].attr(self.elements.attributes.copyContent, self.state.voucherCode);
                        voucherBlockButtons[i].attr(self.elements.attributes.destination, self.state.partnerRedirectUrl);
                    }

                    if (viewData.DisableCta) {
                        $(self.elements.buttons.amazonPrimeSignupButtonComponent).hide();
                    }

                    if (viewData.RewardStatus === null) {
                        return;
                    }

                    self.state.rewardStatus = viewData.RewardStatus.toLowerCase();

                    if (viewData.RewardStatus === self.state.initiated) {
                        $(self.elements.buttons.amazonPrimeSignupButtonClick).text(viewData.ContinueButtonText);
                    }

                    self.func.checkStatus.canRenew(viewData);
                },
                canRenew: function (viewData) {
                    const hasNotApplied = self.state.rewardStatus === self.state.notApplied;
                    const hasExpired = self.state.rewardStatus === self.state.expired;

                    if (viewData.InRenewalPeriod && (hasNotApplied || hasExpired)) {
                        $(self.elements.buttons.amazonPrimeSignupButtonClick).text(viewData.RenewButtonText);
                    }
                }
            },
            getMerchantSiteUrl: function () {
                $.ajax({
                    type: 'GET',
                    url: self.urls.getMerchantSiteUrl,
                    success: self.func.getMerchantSiteUrlSuccess,
                    error: self.func.getMerchantSiteUrlError
                });
            },
            allocateVoucher: function () {
                $.ajax({
                    type: 'GET',
                    url: self.urls.allocateVoucherUrl,
                    success: self.func.allocateVoucherSuccess,
                    error: self.func.allocateVoucherError
                });
            },
            allocateVoucherAndRefresh: function () {
                util.func.callWebApi({
                    type: 'GET',
                    url: self.urls.allocateVoucherUrl
                }).then(
                    util.func.reloadPage
                );
            },
            getMerchantSiteUrlSuccess: function (data) {
                if (data.statusCode === util.httpStatusCodes.ok) {
                    self.state.partnerRedirectUrl = data.redirectUri;
                    if (self.state.rewardStatus === self.state.initiated) {
                        self.func.openCreditContinueModal();
                    } else {
                        self.func.openTermsModal();
                    }
                } else if (data.statusCode === util.httpStatusCodes.unprocessableEntity) {
                    self.func.closeTermsModal();
                    self.func.closeCreditContinueModal();
                    $(self.elements.notifications.amazonPrimeBenefitServiceDown).show();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            getMerchantSiteUrlError: function (jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else {
                    jqxhr.func.redirectToErrorPage();
                }
            },
            allocateVoucherSuccess: function (data) {
                if (data.statusCode === util.httpStatusCodes.ok) {
                    self.state.voucherCode = data.voucherCode;
                    self.func.openVoucherCodeModal();
                } else if (data.statusCode === util.httpStatusCodes.unprocessableEntity) {
                    $(self.elements.notifications.amazonPrimeVoucherAllocationError).show();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            allocateVoucherError: function (jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else {
                    jqxhr.func.redirectToErrorPage();
                }
            },
            redirectToExternalPartnerSite: function () {
                util.func.openInExistingTab(self.state.partnerRedirectUrl);
            },
            redirectToErrorPage: function () {
                util.func.redirect(self.urls.errorPageUrl);
            },
            openTermsModal: function () {
                util.func.openModal(self.elements.ids.amazonPrimeTermsModal);
            },
            openCreditModal: function () {
                util.func.openModal(self.elements.ids.amazonPrimeCreditModal);
            },
            openVoucherCodeModal: function () {
                $(self.elements.ids.amazonPrimeVoucherCode).text(self.state.voucherCode);
                util.func.openModal(self.elements.ids.amazonPrimeVoucherCodeModal);
            },
            openCreditContinueModal: function () {
                util.func.openModal(self.elements.ids.amazonPrimeCreditContinueModal);
            },
            closeTermsModal: function () {
                util.func.closeModal(self.elements.ids.amazonPrimeTermsModal);
            },
            closeVoucherCodeModal: function () {
                util.func.closeModal(self.elements.ids.amazonPrimeVoucherCodeModal);
            },
            closeCreditModal: function () {
                util.func.closeModal(self.elements.ids.amazonPrimeCreditModal);
            },
            closeCreditContinueModal: function () {
                util.func.closeModal(self.elements.ids.amazonPrimeCreditContinueModal);
            },
            copyVoucherCodeAndGo: function () {
                self.func.copyVoucherCode();
                util.func.openInNewTab(self.state.partnerRedirectUrl);
            },
            copyVoucherCode: function () {
                const copyText = self.state.voucherCode;
                const el = document.createElement('textarea');
                el.value = copyText;
                el.setAttribute('readonly', '');
                el.style = {
                    position: 'absolute',
                    left: '-9999px'
                };
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            },
            copyAndGo: function (event) {
                window.copyContent(event.target);
                const destination = $(event.target).attr(self.elements.attributes.destination);
                util.func.openInNewTab(destination);
            }
        }
    };

    return {
        init: self.func.init
    };
})
(jQuery, window.Utilities);

$('document').ready(function () {
    const pageData = $('#page-data');

    if ('amazonprime' !== $(pageData).data('feature')) {
        return;
    }

    const isFeaturePage = 'feature' === $(pageData).data('feature-page');
    const isSignUpPage = 'signup' === $(pageData).data('feature-page');
    const isTrackingPage = 'tracking' === $(pageData).data('feature-page');


    if (isFeaturePage) {
        const element = $('.vds-partner-header__cta-container .vds-partner-header__button-primary');

        if ('False' === $(pageData).data('iseligible')) {
            $(element).removeAttr('href');
            $(element).removeClass();
            $(element).addClass('vds-button vds-button--disabled vds-button vds-cta-block__button vds-partner-header__button');
        }

        if ('True' === $(pageData).data('inrenewalperiod')) {
            const renewButtonText = $(pageData).data('renewButtonText');
            $(element).text(renewButtonText);
        }
    }

    if (isSignUpPage || isTrackingPage) {
        const viewData = $(pageData).data('id');
        window.AmazonPrime.init(viewData);
    }
});
